import moment from 'moment';
import { NButton } from 'naive-ui';
import * as Sentry from "@sentry/browser";
import { App, h } from 'vue';

import i18n from '~/i18n';

export default {
    install: (app: App) => {
        app.config.globalProperties.$notifyError = (message: string, error?: Error) => {
            //@ts-ignore
            console.error(message, error);
            if(!window.$notifications) {
                console.warn(`notifications are initiated could not tell user of error`);
                return;
            }

            const notifier = window.$notifications;
            const $t = i18n.global.t;
            
            const n = notifier.create({
                title: $t('error.global_error_title'),
                content: () => h('span', null, [$t('error.global_error.content')]),
                meta: moment().format('LLL'),
                type: 'error',
                action: () => h(
                    NButton,
                    {
                      text: true,
                      type: 'success',
                      tertiary: true,
                      onClick: () => {
                        let eventId: string = null;
                        if(error && error instanceof Error) {
                            Sentry.withScope((scope: Sentry.Scope) => {
                                scope.setExtras({ message });
                                eventId = Sentry.captureException(error);
                            });
                        } else if(error){
                            Sentry.withScope((scope: Sentry.Scope) => {
                                scope.setExtras({ error });
                                eventId = Sentry.captureMessage(message);
                            });
                        }else {
                            Sentry.withScope(() => {
                                eventId = Sentry.captureMessage(message);
                            });
                        }

                        if(eventId) {
                            notifier.success({
                                content: $t('error.bug_report_sent'),
                            })
                        } else {
                            notifier.error({
                                content: $t('error.bug_report_not_sent'),
                            })
                        }

                        n.destroy();
                      }
                    },
                    {
                      default: () => $t('error.global_error_report'),
                    }
                  ),
            });
        }
    } 
};